/**
 * Lightweight store for tracking the currently active brand ID
 * This is accessible outside React components (e.g., in axios interceptors)
 * 
 * Used to determine which brand-specific token to use for API requests
 */

type ActiveBrandStore = {
  shipperId: string | null
  setShipperId: (id: string | null) => void
  getShipperId: () => string | null
}

export const activeBrandStore: ActiveBrandStore = {
  shipperId: null,
  
  setShipperId(id: string | null) {
    this.shipperId = id
  },
  
  getShipperId() {
    return this.shipperId
  },
}
